export default function FinalCTASection() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <div
          className="rounded-3xl p-8 md:p-12 relative overflow-hidden"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20displaying%20productivity%20dashboard%20alongside%20a%20carefully%20curated%20set%20of%20office%20essentials%20on%20a%20light%20oak%20desk%2C%20warm%20afternoon%20sunlight%20streaming%20through%20a%20window%2C%20soft%20natural%20shadows%2C%20clean%20minimalist%20aesthetic%2C%20editorial%20photography%2C%20high%20detail&width=1200&height=600&seq=cta-itaobuy-v3&orientation=landscape')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-black/30 rounded-3xl"></div>
          <div className="relative z-10">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
              Pronto a scoprire <strong>Itaobuy Spreadsheet</strong>?
            </h2>
            <p className="text-sm md:text-base text-white/85 mb-8 max-w-lg mx-auto leading-relaxed">
              Visita il sito ufficiale e inizia subito a gestire i tuoi dati in modo semplice ed efficiente.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold bg-accent-500 text-background-50 rounded-full hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
              >
                Itaobuy Sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 text-base font-semibold bg-white/90 text-foreground-900 rounded-full hover:bg-white transition-all whitespace-nowrap cursor-pointer"
              >
                Buy It Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}